"use client";

import type { Version } from "@/generated/fastapi";
import GenericSelector from "@/shared/ui/controls/GenericSelector";
import type { VersionSelectorItem } from "./types";

type VersionSelectorProps = {
  selectedVersions: Version[];
  setSelectedVersions: (versions: Version[]) => void;
  selectorEpoch: number;
  versionItems: VersionSelectorItem[];
  versions: Version[];
  placeholder: string;
};

export default function VersionSelector({
  selectedVersions,
  setSelectedVersions,
  selectorEpoch,
  versionItems,
  versions,
  placeholder,
}: VersionSelectorProps) {
  return (
    <GenericSelector<Version>
      key={`version-selector-${versions.length}-${selectorEpoch}`}
      previewItems={versionItems}
      sourceItems={versions}
      stateObject={selectedVersions}
      stateObjectSetter={setSelectedVersions}
      showDescription
      mode="combobox"
      placeholder={placeholder}
      listMaxH="72"
    />
  );
}
